export default [{
  ariaLabel: 'Sort Results By Relevance',
  label: 'Relevance',
  value: 'default'
}, {
  ariaLabel: 'Sort Results By Price Low To High',
  label: 'Price ($-$$)',
  sort: function sort(result1, result2) {
    return result1.price - result2.price;
  },
  value: 'price-low-high'
}];